import CourseCategoryContainer from './CourseCategoryContainer';

export default CourseCategoryContainer;